// Port of api/fuel/app/classes/model/custom/rename.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'custom_rename',
	prefix: '',
	key: 'custom_rename_id',
	fields: {
		custom_rename_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		collection_id: Model.SCHEMA_NUMBER,
		custom_rename_text: Model.SCHEMA_TEXT,
		custom_rename_public: Model.SCHEMA_NUMBER,
		custom_rename_context: Model.SCHEMA_NUMBER
	}
})
